<template>
    <div class="progress">
        <div class="progress-bar" role="progressbar"
             :style="styles"
             aria-valuenow="value"
             aria-valuemin="0" aria-valuemax="100">
            {{ value }}%
        </div>
    </div>
</template>

<script>
export default {
    props: ['value'],
    computed: {
        styles() {
            return {
                width: `${this.value}%`,
            };
        }
    }
}
</script>
